import { useTranslation } from 'next-i18next';

import { logger } from '@zep/core-logger';

import { alertDialog } from '@/ui_v3';

export const useBuildAiQueryErrorAlert = () => {
  const { t } = useTranslation(['build', 'common']);

  return (e: Error, errorEventName: string) => {
    alertDialog.open({
      header: {
        title: t('build.ai.failBuildAiQuiz'),
        hasCloseButton: false,
      },
      body: t('build:ai.buildQuery.failDescription'),
    });
    logger.track(errorEventName, { error_name: e.name });
  };
};
